import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import { createTheme, ThemeProvider } from '@material-ui/core/styles'
import { useEffect } from 'react'
import { 
    Select, 
    MenuItem, 
    InputLabel, 
    Checkbox, 
    FormControl, 
    FormHelperText,
    LinearProgress
} from '@material-ui/core'
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab'
import TextField from '@material-ui/core/TextField'
import ScheduleIcon from '@material-ui/icons/Schedule'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import CloseIcon from '@material-ui/icons/Close'
import RefreshIcon from '@material-ui/icons/Refresh'
import Alert from '@material-ui/lab/Alert'
import DateFnsUtils from '@date-io/moment'
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers'
import MaterialTable from 'material-table'
import moment from 'moment'
import {
    getScheduledReports,
    createScheduledReport,
    updateScheduledReport,
    deleteScheduledReport
} from '../../api/api'
import ClientSelector from '../shared/ClientSelector'
import queryString from 'query-string'; // Import query-string library

// Add utility function for date formatting
const dateToLocalString = date => {
    if (!date) return '-'
    return dateFns.moment.utc(date).local().format('YYYY-MM-DD HH:mm:ss')
}

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    dialog: {
        '& .MuiDialog-paper': {
            overflow: 'hidden'
        },
        '& .MuiDialogContent-root': {
            overflow: 'hidden'
        },
        '& .MuiDialog-paperScrollPaper': {
            overflow: 'hidden'
        }
    },
    formControl: {
        width: '100%',
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1)
    },
    docTypeSelect: {},
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper
    },
    // editReportTextField: {
    //     width: '100%',
    //     marginTop: theme.spacing(3),
    //     marginBottom: theme.spacing(1)
    // },
    editReportTextField: {
        width: '150px'
    },
    toggleGroup: {
        marginTop: theme.spacing(1),
        '& .MuiToggleButton-root.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            '&:hover': {
                backgroundColor: theme.palette.primary.dark
            }
        }
    },
    sectionTitle: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(2)
    },
    gridContainer: {
        marginTop: theme.spacing(2)
    },
    formLabel: {
        marginTop: theme.spacing(2)
    },
    dateNote: {
        marginTop: theme.spacing(1),
        color: theme.palette.text.secondary,
        fontSize: '0.875rem'
    }
}))

const dateFns = new DateFnsUtils()

export default function ScheduledReportsManagementDialog(props) {
    const classes = useStyles()
    const [open, setOpen] = React.useState(false)
    const [isLoading, setIsLoading] = React.useState(false)
    const [isSuccess, setIsSuccess] = React.useState(false)
    const [successMessage, setSuccessMessage] = React.useState('View Saved!')
    const [isError, setIsError] = React.useState(false)
    const [errorMessage, setErrorMessage] = React.useState('')
    const [changesMade, setChangesMade] = React.useState(false)
    const [selectedReport, setSelectedReport] = React.useState(null)
    const [allReports, setAllReports] = React.useState([])
    const [editDialogOpen, setEditDialogOpen] = React.useState(false)
    const [isNewReport, setIsNewReport] = React.useState(false)
    const [nameInputHelperText, setNameInputHelperText] = React.useState(null)
    const [nameInputError, setInputNameError] = React.useState(false)
    const [emailInputHelperText, setEmailInputHelperText] = React.useState(null)
    const [emailInputError, setEmailInputError] = React.useState(false)
    const [clients, setClients] = React.useState([])
    const [selectedClientIds, setSelectedClientIds] = React.useState([])
    const [mode, setMode] = React.useState('ALL')
    const [gridSearchTypes, setGridSearchTypes] = React.useState([])
    const [referenceType, setReferenceType] = React.useState('')
    const [itemReference, setItemReference] = React.useState('')
    const [dateView, setDateView] = React.useState('ALL')
    const [dateFiltering, setDateFiltering] = React.useState([])
    const [selectedDate, setSelectedDate] = React.useState(2) // this month by default
    const [fromDate, setFromDate] = React.useState(moment().startOf('month'))
    const [toDate, setToDate] = React.useState(moment().endOf('month'))

    // check if showDialog props is true
    useEffect(() => {
        if (props.showDialog) {
            handleScheduledReportsClickOpen().then(() => {
                // Set all the initial values from newReportData
                setSelectedReport(props.newReportData)
                if (props.newReportData) {
                    setMode(props.newReportData.transportMode)
                    setReferenceType(props.newReportData.referenceType)
                    setItemReference(props.newReportData.itemReference)
                    setDateView(props.newReportData.dateView)
                    setSelectedDate(props.newReportData.selectedDate)
                    setFromDate(props.newReportData.fromDate)
                    setToDate(props.newReportData.toDate)
                    setSelectedClientIds([props.newReportData.clientId])
                }
                setIsNewReport(true)
                setEditDialogOpen(true)
            })
        } else {
            setIsNewReport(false)
        }
    }, [props.showDialog])

    useEffect(() => {
        // Set grid search types from props
        if (props.reportSearchTypes) {
            setGridSearchTypes(props.reportSearchTypes)
            if (props.reportSearchTypes.length > 0) {
                setReferenceType(props.reportSearchTypes[0].searchType)
            }
        }
    }, [props.reportSearchTypes])

    useEffect(() => {
        // Set date filtering from props
        if (props.reportDateOptions) {
            setDateFiltering(props.reportDateOptions)
        }
    }, [props.reportDateOptions])

    useEffect(() => {
        // Set clients from props
        if (props.clients) {
            setClients(props.clients)
            if (props.clients.length > 0) {
                setSelectedClientIds([props.clients[0]?.id])
            }
        }
    }, [props.clients])

    useEffect(() => {
        async function fetchData() {
            await fetchScheduledReports()
        }
        fetchData()
    }, [])

    const { palette } = createTheme()
    const theme = createTheme({
        palette: {
            primary: {
                main: props.backgroundColor,
                contrastText: props.fontColor
            }
        }
    })

    const fetchScheduledReports = async () => {
        setIsLoading(true)

        const fetchedReports = await getScheduledReports(props.relatedModule)

        setAllReports(fetchedReports)
        setIsLoading(false)
    }

    const handleScheduledReportsClickOpen = async () => {
        await fetchScheduledReports()
        setOpen(true)
    }

    const getSelectStartHourMenuItems = () => {
        const menuItems = []
        for (let i = 0; i < 24; i++) {
            menuItems.push(<MenuItem key={i} value={i}>{`${i}:00`}</MenuItem>)
        }
        return menuItems
    }

    const handleClose = () => {
        if (changesMade) {
            if (!window.confirm('Cancel without saving changes?')) {
                return
            } else {
                setChangesMade(false)
            }
        }
        setIsError(false)
        setErrorMessage('')
        setIsSuccess(false)
        setOpen(false)
        props.closeDialog()
    }

    const handleSuccess = successMessage => {
        setChangesMade(false)
        setSuccessMessage(successMessage)
        setIsSuccess(true)
        setInterval(function () {
            // call callback function passed in from props
            setIsSuccess(false)
        }, 3000)
    }

    const handleDeleteError = errorMessage => {
        setErrorMessage(errorMessage)
        setIsError(true)
        setIsLoading(false)
    }

    const handleDeleteSuccess = () => {
        setIsLoading(false)
        handleSuccess('Report Successfully Removed!')
        fetchScheduledReports()
    }

    const handleError = errorMessage => {
        setErrorMessage(errorMessage)
        setIsError(true)
    }

    const handleEditReportDialogClose = () => {
        setEditDialogOpen(false)
        // refresh the list of reports
        fetchScheduledReports()
        if (isNewReport) handleClose()
    }

    const handleDeleteReport = async id => {
        if (!window.confirm('Are you sure you want to delete this report?')) {
            return
        }
        setIsLoading(true)
        const response = await deleteScheduledReport(id)
        if (response !== null) {
            handleDeleteSuccess()
        } else {
            handleDeleteError('Error Deleting Scheduled Report')
        }
    }

    const getUTCDateTime = (date, hour) => {
        if (!date) {
            if (!hour) {
                return dateFns.moment.utc(new Date())
            }
            return dateFns.moment.utc(new Date()).hour(hour)
        }

        // need to set the hour before converting to UTC
        date = new Date(date)
        date = date.setHours(hour || 0, 0, 0, 0)

        return dateFns.moment.utc(date).format('YYYY-MM-DDTHH:mm:ss')
    }

    // Helper functions for parameter encoding/decoding
    const decodeParameters = (base64Str) => {
        if (!base64Str) return null;
        
        try {
            // Check if the string is already a JSON object
            if (typeof base64Str === 'object') {
                return base64Str;
            }
            
            // Try parsing as JSON first in case it's not base64 encoded
            try {
                return JSON.parse(base64Str);
            } catch {
                // If JSON parse fails, try base64 decode
                const decoded = atob(base64Str);
                return JSON.parse(decoded);
            }
        } catch (e) {
            console.error('Error decoding parameters:', e);
            return null;
        }
    };

    const encodeParameters = (paramsObj) => {
        try {
            const jsonStr = JSON.stringify(paramsObj);
            return btoa(jsonStr);
        } catch (e) {
            console.error('Error encoding parameters:', e);
            return null;
        }
    };

    const handleEditReportDialogSubmission = async () => {
        // check that name and email address are not empty
        if (!selectedReport?.name) {
            setInputNameError(true)
            setNameInputHelperText('Name is required')
        } else {
            setInputNameError(false)
            setNameInputHelperText(null)
        }

        if (!selectedReport?.emailAddress) {
            setEmailInputError(true)
            setEmailInputHelperText('Email Address is required')
        } else {
            setEmailInputError(false)
            setEmailInputHelperText(null)
        }

        if (!selectedReport?.name || !selectedReport?.emailAddress) {
            return
        }

        // check if each email address is valid
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        // emails are separated by semi-colons
        const emailAddresses = selectedReport?.emailAddress.split(';')
        for (let i = 0; i < emailAddresses.length; i++) {
            if (!emailRegex.test(emailAddresses[i].trim())) {
                setEmailInputError(true)
                setEmailInputHelperText('Invalid Email Address')
                return
            }
        }

        const currentParams = isNewReport ? queryString.parse(selectedReport?.reportQueryString || '') : decodeParameters(selectedReport?.parameters);

        const updatedParams = {
            ...currentParams,
            Mode: mode,
            ReferenceType: referenceType,
            ShipmentSearchNumber: itemReference,
            OrderSearchNumber: itemReference,
            DateType: dateView,
            SelectedDate: selectedDate,
            FromDate: moment(fromDate).format('YYYY-MM-DD') + 'T00:00:00Z',
            ToDate: moment(toDate).format('YYYY-MM-DD') + 'T23:59:59Z',
            FromDateAsDate: moment(fromDate).format('YYYY-MM-DD') + 'T13:00:00+13:00',
            ToDateAsDate: moment(toDate).format('YYYY-MM-DD') + 'T12:59:59+13:00',
            ClientId: selectedClientIds[0]
        };

        if (isNewReport) {
            // handle new report submission
            setIsLoading(true)
            var newReport = {
                Name: selectedReport?.name,
                JobType: 0,
                RelatedModule: props.relatedModule,
                Frequency: selectedReport?.frequency,
                NextRunDate: getUTCDateTime(
                    selectedReport?.nextRunDate ?? dateFns.moment.utc(new Date()),
                    selectedReport?.nextRunTime ?? 6
                ),
                IsActive: selectedReport?.isActive,
                EmailAddress: selectedReport?.emailAddress,
                ReportQueryString: queryString.stringify(updatedParams),
                FromDateType: selectedReport?.fromDateType || 'fixed',
                ToDateType: selectedReport?.toDateType || 'fixed'
            }

            const response = await createScheduledReport(newReport)

            if (response !== null) {
                handleSuccess('Scheduled Report Created!')
                fetchScheduledReports()
            } else {
                handleError('Error Creating Scheduled Report')
            }
        } else {
            // handle edit report submission
            setIsLoading(true)
            
            var updatedReport = {
                Id: selectedReport?.id,
                Name: selectedReport?.name,
                JobType: 0,
                RelatedModule: selectedReport?.relatedModule,
                Frequency: selectedReport?.frequency,
                NextRunDate: getUTCDateTime(
                    selectedReport?.nextRunDate,
                    selectedReport?.nextRunTime
                ),
                IsActive: selectedReport?.isActive,
                EmailAddress: selectedReport?.emailAddress,
                FromDateType: selectedReport?.fromDateType || 'fixed',
                ToDateType: selectedReport?.toDateType || 'fixed',
                EncodedParameters: encodeParameters(updatedParams)
            };

            try {
                const response = await updateScheduledReport(updatedReport)
                if (response !== null) {
                    fetchScheduledReports()
                    handleSuccess('Scheduled Report Updated!')
                } else {
                    handleError('Error Updating Scheduled Report')
                }
            } catch (error) {
                handleError('Error Updating Scheduled Report: ' + error.message)
            }
        }

        setEditDialogOpen(false)
        setIsLoading(false)
    }

    const handleClientSelectChange = (clientIds) => {
        setSelectedClientIds(clientIds)
        // updateParameters('ClientId', clientIds[0])
    }

    const renderReportEditDialog = () => {
        // need to render a new dialog to show when the user clicks the edit icon on a specific column
        // this dialog will allow the user to change the column name and other properties
        // the dialog will have a text field for the column name, a checkbox for visible, and a checkbox for required
        // the dialog will have a save and cancel button
        // the dialog will have a delete button if the column is not required
        // the dialog will have a close button

        return (
            <Dialog
                open={editDialogOpen}
                onClose={handleEditReportDialogClose}
                fullWidth
            >
                <DialogTitle>{`${isNewReport ? 'Create New' : 'Edit'} Scheduled Report${!isNewReport ? ' - ' + selectedReport?.name : ''}`}</DialogTitle>
                <DialogContent style={{ overflowY: 'auto', overflowX: 'hidden', maxHeight: '80vh' }}>
                    <Grid container spacing={3} className={classes.gridContainer}>
                        <Grid item xs={6}>
                            <InputLabel id="select-label-client">
                                Client
                            </InputLabel>
                            <ClientSelector
                                clients={clients}
                                selectedClientIds={selectedClientIds ? selectedClientIds : []}
                                handleClientSelection={handleClientSelectChange}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <InputLabel>Transport Mode</InputLabel>
                            <Select
                                value={mode}
                                onChange={(e) => {
                                    setMode(e.target.value);
                                    // updateParameters('Mode', e.target.value);
                                }}
                                label="Mode"
                            >
                                <MenuItem value={'ALL'}>All</MenuItem>
                                <MenuItem value={'SEA'}>Sea</MenuItem>
                                <MenuItem value={'AIR'}>Air</MenuItem>
                                <MenuItem value={'COU'}>Courier</MenuItem>
                                <MenuItem value={'ROA'}>Road</MenuItem>
                                <MenuItem value={'RAI'}>Rail</MenuItem>
                            </Select>
                        </Grid>
                        <Grid item xs={6}>
                            <InputLabel id="select-label-referencetype">Search Type</InputLabel>
                            <Select
                                labelId="select-label-referencetype"
                                id="reference-type"
                                value={referenceType}
                                onChange={(e) => {
                                    setReferenceType(e.target.value);
                                    // updateParameters('ReferenceType', e.target.value);
                                }}
                                label="Search Type"
                            >
                                {
                                    gridSearchTypes
                                        .filter(type => type.dropdownName === 'Search Type')
                                        .map((type, i) => (
                                            <MenuItem
                                                key={i + 1}
                                                value={type.searchType}
                                            >
                                                {type.searchTypeDescription}
                                            </MenuItem>
                                        ))
                                }
                            </Select>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                style={{ marginTop: '12px' }}
                                size="small"
                                id="reference"
                                label="Reference # (3 chars min)"
                                labelid="Reference2"
                                placeholder="Reference # (3 chars min)"
                                value={itemReference}
                                onChange={(e) => {
                                    setItemReference(e.target.value);
                                }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <InputLabel id="select-label-dateview">Date View</InputLabel>
                            <Select
                                labelId="select-label-dateview"
                                id="dateView"
                                value={dateView}
                                onChange={(e) => {
                                    setDateView(e.target.value);
                                    // updateParameters('DateType', e.target.value);
                                }}
                                label="Date View"
                            >
                                {
                                    gridSearchTypes
                                        .filter(type => type.dropdownName === 'Date View')
                                        .map((type, i) => (
                                            <MenuItem
                                                key={i + 1}
                                                value={type.searchType}
                                            >
                                                {type.searchTypeDescription}
                                            </MenuItem>
                                        ))
                                }
                            </Select>
                        </Grid>
                        <Grid item xs={6}>
                            <InputLabel>Date Range</InputLabel>
                            <Select
                                id="editReportDateRange"
                                value={selectedDate}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const { from, to } = setDatesFromDateDropdown(value);
                                                                            
                                    // First update the state
                                    setSelectedDate(value);
                                    setFromDate(from);
                                    setToDate(to);
                                    
                                    // Then update the report parameters
                                    setSelectedReport(prevReport => {
                                        const currentParams = queryString.parse(prevReport?.reportQueryString || '');
                                        
                                        const updatedParams = {
                                            ...currentParams,
                                            SelectedDate: value,
                                            FromDate: moment(from).format('YYYY-MM-DD') + 'T00:00:00Z', 
                                            ToDate: moment(to).format('YYYY-MM-DD') + 'T23:59:59Z', 
                                            FromDateAsDate: moment(from).format('YYYY-MM-DD') + 'T13:00:00+13:00',
                                            ToDateAsDate: moment(to).format('YYYY-MM-DD') + 'T12:59:59+13:00'
                                        };
                                                                                    
                                        return {
                                            ...prevReport,
                                            fromDate: from,
                                            toDate: to,
                                            selectedDate: value,
                                            reportQueryString: queryString.stringify(updatedParams)
                                        };
                                    });
                                }}
                                label="Date Range"
                            >
                                {dateFiltering.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                            <FormHelperText>*Report from/to dates will be dynamic based on 'Date Range' selection</FormHelperText>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} className={classes.gridContainer}>
                        <Grid item xs={6}>
                            <div>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker
                                        autoOk
                                        format={props.organization?.pickerDateFormat}
                                        label="From Date"
                                        value={selectedReport?.fromDate || fromDate}
                                        onChange={(date) => {
                                            setFromDate(date);
                                            const formattedDate = moment(date).format('YYYY-MM-DD');
                                            setSelectedReport(prevReport => {
                                                const currentParams = queryString.parse(prevReport?.reportQueryString || '');
                                                const updatedParams = {
                                                    ...currentParams,
                                                    FromDate: `${formattedDate}T00:00:00Z`,
                                                    FromDateAsDate: `${formattedDate}T13:00:00+13:00`
                                                };
                                                return {
                                                    ...prevReport,
                                                    fromDate: date,
                                                    reportQueryString: queryString.stringify(updatedParams)
                                                };
                                            });
                                        }}
                                        disabled={selectedReport?.selectedDate !== 11}
                                        className={classes.editReportTextField}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                            <ToggleButtonGroup
                                color="primary"
                                value={selectedReport?.fromDateType || 'fixed'} // need to make this exclusive
                                exclusive
                                onChange={(_, value) => {
                                    if (value !== null) {
                                        setSelectedReport({
                                            ...selectedReport,
                                            fromDateType: value
                                        });
                                    }
                                }}
                                aria-label="FromDateType"
                                id="editReportFromDateType"
                                className={classes.toggleGroup}
                            >
                                <ToggleButton value="fixed" disabled={selectedReport?.selectedDate !== 11} >Fixed</ToggleButton>
                                <ToggleButton value="relative" disabled={selectedReport?.selectedDate !== 11}>
                                    Relative
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControl className="mx-auto calender-icon-controller">
                                <div>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker
                                            autoOk
                                            format={props.organization?.pickerDateFormat}
                                            label="To Date"
                                            value={selectedReport?.toDate || toDate}
                                            minDate={fromDate}
                                            onChange={(date) => {
                                                setToDate(date);
                                                const formattedDate = moment(date).format('YYYY-MM-DD');
                                                setSelectedReport(prevReport => {
                                                    const currentParams = queryString.parse(prevReport?.reportQueryString || '');
                                                    const updatedParams = {
                                                        ...currentParams,
                                                        ToDate: `${formattedDate}T23:59:59Z`,
                                                        ToDateAsDate: `${formattedDate}T12:59:59+13:00`
                                                    };
                                                    return {
                                                        ...prevReport,
                                                        toDate: date,
                                                        reportQueryString: queryString.stringify(updatedParams)
                                                    };
                                                });
                                            }}
                                            disabled={selectedReport?.selectedDate !== 11}
                                            className={classes.editReportTextField}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </FormControl>
                            <ToggleButtonGroup
                                color="primary"
                                value={selectedReport?.toDateType || 'fixed'} // need to make this exclusive
                                exclusive
                                onChange={(_, value) => {
                                    if (value !== null) {
                                        setSelectedReport({
                                            ...selectedReport,
                                            toDateType: value
                                        });
                                    }
                                }}
                                aria-label="ToDateType"
                                id="editReportToDateType"
                                className={classes.toggleGroup}
                            >
                                <ToggleButton value="fixed" disabled={selectedReport?.selectedDate !== 11}>Fixed</ToggleButton>
                                <ToggleButton value="relative" disabled={selectedReport?.selectedDate !== 11}>
                                    Relative
                                </ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>
                    </Grid>
                    <br />
                    <p style={{ fontSize: '12px', color: 'gray' }}>
                        <strong>Note</strong>: Relative date range will be
                        calculated based on the current date.
                    </p>
                    <br />
                    <h4>Report Details</h4>
                    <br />
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                id="editReportName"
                                label="Name"
                                required
                                error={nameInputError}
                                helperText={nameInputHelperText}
                                className={classes.editReportTextField}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                variant="outlined"
                                defaultValue={selectedReport?.name}
                                margin="normal"
                                onChange={e =>
                                    setSelectedReport({
                                        ...selectedReport,
                                        name: e.target.value
                                    })
                                }
                            />
                            <br />
                            <TextField
                                id="editReportEmailAddress"
                                label="Email Address (separate multiple emails with a semi-colon)"
                                required
                                error={emailInputError}
                                helperText={emailInputHelperText}
                                className={classes.editReportTextField}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                variant="outlined"
                                defaultValue={selectedReport?.emailAddress}
                                margin="normal"
                                type="email"
                                onChange={e =>
                                    setSelectedReport({
                                        ...selectedReport,
                                        emailAddress: e.target.value
                                    })
                                }
                            />
                            <br />
                            <InputLabel id="editReportFrequencyLabel">
                                Frequency
                            </InputLabel>
                            <Select
                                id="editReportFrequency"
                                required
                                value={selectedReport?.frequency || 0}
                                margin="normal"
                                className={classes.editReportTextField}
                                onChange={e =>
                                    setSelectedReport({
                                        ...selectedReport,
                                        frequency: e.target.value
                                    })
                                }
                            >
                                <MenuItem value={0}>Daily</MenuItem>
                                <MenuItem value={1}>Weekly</MenuItem>
                                <MenuItem value={2}>Monthly</MenuItem>
                            </Select>
                            <br />
                            <br />
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <MuiPickersUtilsProvider
                                        utils={DateFnsUtils}
                                    >
                                        <KeyboardDatePicker
                                            margin="normal"
                                            id="editReportStartDate"
                                            autoOk
                                            label={
                                                isNewReport
                                                    ? 'First Run Date'
                                                    : 'Next Run Date'
                                            }
                                            format={
                                                props.organization
                                                    ?.pickerDateFormat
                                            }
                                            value={
                                                selectedReport?.nextRunDate ||
                                                new Date()
                                            }
                                            onChange={date => {
                                                setSelectedReport({
                                                    ...selectedReport,
                                                    nextRunDate: date
                                                })
                                            }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date'
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item xs={6}>
                                    <InputLabel id="editReportStartHourLabel">
                                        {isNewReport
                                            ? 'First Run Hour'
                                            : 'Next Run Hour'}
                                    </InputLabel>
                                    <Select
                                        id="editReportStartHour"
                                        value={selectedReport?.nextRunTime || 6}
                                        margin="normal"
                                        style={{ marginTop: '5px' }}
                                        className={classes.editReportTextField}
                                        onChange={e =>
                                            setSelectedReport({
                                                ...selectedReport,
                                                nextRunTime: e.target.value
                                            })
                                        }
                                    >
                                        {getSelectStartHourMenuItems()}
                                    </Select>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Checkbox
                                        id="editReportActive"
                                        checked={selectedReport?.isActive}
                                        onChange={e =>
                                            setSelectedReport({
                                                ...selectedReport,
                                                isActive: e.target.checked
                                            })
                                        }
                                        inputProps={{
                                            'aria-label': 'primary checkbox'
                                        }}
                                    />
                                    <label htmlFor="editReportActive">
                                        Active
                                    </label>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <ThemeProvider theme={theme}>
                    <DialogActions>
                        <Button
                            onClick={handleEditReportDialogClose}
                            color="primary"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleEditReportDialogSubmission}
                            color="primary"
                        >
                            Save
                        </Button>
                    </DialogActions>
                </ThemeProvider>
            </Dialog>
        )
    }

    const setEditReportParameters = (reportParameters) => {
        // set the parameters for the report
        setMode(reportParameters?.Mode || 'ALL')    
        setReferenceType(reportParameters?.ReferenceType || '')
        setItemReference(reportParameters?.ShipmentSearchNumber || reportParameters?.OrderSearchNumber || '')
        setDateView(reportParameters?.DateType || 'ALL')
        setSelectedDate(reportParameters?.SelectedDate || 2)
        setFromDate(reportParameters?.FromDate || moment().startOf('month'))    
        setToDate(reportParameters?.ToDate || moment().endOf('month'))
        setSelectedClientIds([reportParameters?.ClientId || ''])
    }


    const handleReportSelection = id => {
        let editReport = allReports.find(report => report.id === id)
        if (!editReport) return;

        editReport.nextRunTime = dateFns.moment
            .utc(editReport.nextRunDate)
            .local()
            .hour()
        editReport.nextRunDate = dateFns.moment
            .utc(editReport.nextRunDate)
            .local()
            .format('YYYY-MM-DD')

        setSelectedReport(editReport)
        setEditReportParameters(decodeParameters(editReport.parameters))

        setIsNewReport(false)
        setEditDialogOpen(true)
    }

    const renderReportList = () => {
        const reportsTableTheme = createTheme({
            palette: {
                primary: {
                    main: props.backgroundColor,
                    contrastText: props.fontColor
                }
            }
        })

        return (
            <MaterialTable
                title="Scheduled Reports"
                columns={[
                    {
                        title: 'Edit',
                        field: 'edit',
                        type: 'string',
                        render: rowData => (
                            <IconButton
                                onClick={() =>
                                    handleReportSelection(rowData.id)
                                }
                            >
                                <EditIcon />
                            </IconButton>
                        ),
                        cellStyle: { whiteSpace: 'nowrap' },
                        headerStyle: { whiteSpace: 'nowrap' }
                    },
                    {
                        title: 'Delete',
                        field: 'delete',
                        type: 'string',
                        render: rowData => (
                            <IconButton
                                onClick={() => handleDeleteReport(rowData.id)}
                            >
                                <DeleteIcon />
                            </IconButton>
                        ),
                        cellStyle: { whiteSpace: 'nowrap' },
                        headerStyle: { whiteSpace: 'nowrap' }
                    },
                    {
                        title: 'Active',
                        field: 'isActive',
                        type: 'boolean',
                        render: rowData => (rowData.isActive ? 'Yes' : 'No'),
                        cellStyle: { whiteSpace: 'nowrap' },
                        headerStyle: { whiteSpace: 'nowrap' }
                    },
                    {
                        title: 'Name',
                        field: 'name',
                        type: 'string',
                        cellStyle: { whiteSpace: 'nowrap', fontWeight: 'bold' },
                        headerStyle: { whiteSpace: 'nowrap' }
                    },
                    {
                        title: 'Status',
                        field: 'currentStatusString',
                        type: 'string',
                        cellStyle: { whiteSpace: 'nowrap' },
                        headerStyle: { whiteSpace: 'nowrap' }
                    },
                    {
                        title: 'Frequency',
                        field: 'frequencyString',
                        type: 'string',
                        cellStyle: { whiteSpace: 'nowrap' },
                        headerStyle: { whiteSpace: 'nowrap' }
                    },
                    {
                        title: 'Email Address',
                        field: 'emailAddress',
                        type: 'string',
                        cellStyle: { whiteSpace: 'nowrap' },
                        headerStyle: { whiteSpace: 'nowrap' }
                    },
                    {
                        title: 'Next Run',
                        field: 'nextRunDate',
                        type: 'datetime',
                        render: rowData =>
                            dateToLocalString(rowData.nextRunDate),
                        cellStyle: { whiteSpace: 'nowrap' },
                        headerStyle: { whiteSpace: 'nowrap' }
                    },
                    {
                        title: 'Last Run',
                        field: 'lastRunDate',
                        type: 'datetime',
                        render: rowData =>
                            dateToLocalString(rowData.lastRunDate),
                        cellStyle: { whiteSpace: 'nowrap' },
                        headerStyle: { whiteSpace: 'nowrap' }
                    },
                    {
                        title: 'Last Run Duration',
                        field: 'lastRunDurationString',
                        type: 'string',
                        cellStyle: { whiteSpace: 'nowrap' },
                        headerStyle: { whiteSpace: 'nowrap' }
                    },
                    {
                        title: 'Created By',
                        field: 'createdByString',
                        type: 'string',
                        cellStyle: { whiteSpace: 'nowrap' },
                        headerStyle: { whiteSpace: 'nowrap' }
                    },
                    {
                        title: 'Created',
                        field: 'createdDate',
                        type: 'datetime',
                        render: rowData =>
                            dateToLocalString(rowData.createdDate),
                        cellStyle: { whiteSpace: 'nowrap' },
                        headerStyle: { whiteSpace: 'nowrap' }
                    },
                    {
                        title: 'Modified By',
                        field: 'modifiedByString',
                        type: 'string',
                        cellStyle: { whiteSpace: 'nowrap' },
                        headerStyle: { whiteSpace: 'nowrap' }
                    },
                    {
                        title: 'Modified',
                        field: 'modifiedDate',
                        type: 'datetime',
                        render: rowData =>
                            dateToLocalString(rowData.modifiedDate),
                        cellStyle: { whiteSpace: 'nowrap' },
                        headerStyle: { whiteSpace: 'nowrap' }
                    }
                ]}
                data={allReports}
                options={{
                    search: false,
                    paging: false,
                    sorting: false,
                    showTitle: false,
                    toolbar: false
                }}
                components={{
                    Container: props => <div {...props} />
                }}
                theme={reportsTableTheme}
            />
        )
    }

    const setDatesFromDateDropdown = value => {
        let from, to;
        
        switch(parseInt(value)) {
            case 0: // Today
                from = moment().startOf('day');
                to = moment().endOf('day');
                break;
            case 1: // This Week
                from = moment().startOf('week');
                to = moment().endOf('week');
                break;
            case 2: // This Month
                from = moment().startOf('month');
                to = moment().endOf('month');
                break;
            case 3: // This Year
                from = moment().startOf('year');
                to = moment().endOf('year');
                break;
            case 4: // Next Week
                from = moment().add(1, 'week').startOf('week');
                to = moment().add(1, 'week').endOf('week');
                break;
            case 5: // Next Month
                from = moment().add(1, 'month').startOf('month');
                to = moment().add(1, 'month').endOf('month');
                break;
            case 6: // Next Year
                from = moment().add(1, 'year').startOf('year');
                to = moment().add(1, 'year').endOf('year');
                break;
            case 7: // Last Week
                from = moment().subtract(1, 'week').startOf('week');
                to = moment().subtract(1, 'week').endOf('week');
                break;
            case 8: // Last Month
                from = moment().subtract(1, 'month').startOf('month');
                to = moment().subtract(1, 'month').endOf('month');
                break;
            case 9: // Last Year
                from = moment().subtract(1, 'year').startOf('year');
                to = moment().subtract(1, 'year').endOf('year');
                break;
            case 10: //All Time
                from = fromDate;
                to = toDate;
                break;
            case 11: //Custom
                from = moment(fromDate);
                to = moment(toDate);
                break;
            default:
                from = moment().startOf('month');
                to = moment().endOf('month');
        }

        return { from, to };
    };

    return (
        <>
            <IconButton
                style={{ float: 'left', zIndex: 99 }}
                color="inherit"
                size="small"
                onClick={handleScheduledReportsClickOpen}
                disableRipple
                disableFocusRipple
            >
                <ScheduleIcon />
                Scheduled Reports
            </IconButton>

            <Dialog maxWidth={'xl'} open={open} onClose={handleClose} className={classes.dialog}>
                <DialogTitle
                    style={{
                        textAlign: 'center',
                        color: props.fontColor,
                        backgroundColor: props.backgroundColor
                    }}
                >
                    {'Scheduled Reports: ' + props.viewName}
                </DialogTitle>
                <DialogContent style={{ overflow: 'hidden' }}>
                    {isLoading && <LinearProgress />}
                    {
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                {
                                    // put list of scheduled reports here
                                    renderReportList()
                                }
                            </Grid>
                        </Grid>
                    }
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={fetchScheduledReports}
                        variant="outlined"
                        disabled={isLoading}
                        startIcon={<RefreshIcon />}
                    >
                        Refresh
                    </Button>
                    <Button
                        sx={{ minWidth: '100px' }}
                        onClick={handleClose}
                        variant="outlined"
                        disabled={isLoading}
                    >
                        Close
                    </Button>
                </DialogActions>
                {isSuccess && (
                    <Alert severity="success" variant="filled">
                        {successMessage}
                    </Alert>
                )}
                {isError && (
                    <Alert
                        severity="error"
                        variant="filled"
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setIsError(false)
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                    >
                        {errorMessage}
                    </Alert>
                )}
            </Dialog>
            {renderReportEditDialog()}
        </>
    )
}
